import BsSelect from './index.vue'
export default BsSelect